export const ICON_TYPES = {
    APP_INSTALL: 'APP_INSTALL',
    PERFORMANCE_VIDEO: 'PERFORMANCE_VIDEO',
    HTML_CARD: 'HTML_CARD',
};
